import React from 'react'
import Layout from '../components/Layout/Layout'
import { MdDataThresholding } from 'react-icons/md'

const HowItWorks = () => {
  return (
    <>
      <Layout>
        <div className="background-container d-flex justify-content-center align-items-center">
          <video className="background-video" autoPlay muted loop>
            <source src="https://cdn.sanity.io/files/qdwjwavs/production/009a75af8e3bf8671283dfec51e792f436272a6e.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <main className="main-section row">
            <div className="col-md-8 mx-auto">
              <h1 className="text_48_how text-center">IMMSY's Integrated Wellness Ecosystem</h1>
              <p className="text_24_how">
                Combining advanced technologies with personalized care for an unmatched wellness experience.
              </p>
              <p className="text_18_how">
                At IMMSY, we leverage state-of-the-art technologies and a personalized approach to provide a fully integrated wellness experience, available 24/7. Our platform and retreat centers work together to create a seamless journey towards holistic health.
              </p>
            </div>
          </main>
        </div>


        <section
          className="py-2"
          style={{
            backgroundImage:
              'url("https://cdn.sanity.io/images/qdwjwavs/production/b966d61b9e716ba31789ae60d8bb0a7a95eeb162-2878x1600.jpg?w=1600")',
          }}
        >
          <div className="container">
            <div className="row justify-content-start align-items-center">
              <div className="col-md-8 section-content">
                <h2 className="text_48_how">Data Collection and Analysis</h2>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Data Collection:</strong> Our AI-powered platform gathers data from user inputs, wearable devices, and health reports, including descriptions of symptoms, emotions, and experiences.</p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Natural Language Processing (NLP):</strong> Advanced NLP interprets the context, emotions, and nuances in user inputs for personalized and empathetic responses.</p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Pattern Recognition:</strong> Machine learning algorithms identify patterns and insights, enabling tailored wellness recommendations.</p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Risk Assessment:</strong> Evaluates risk levels for health conditions, allowing early detection and intervention.</p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Response Generation:</strong> Generates personalized fitness plans, mental health strategies, or nutritional advice based on data analysis.</p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Continuous Feedback Loop:</strong> Learns and adapts from user interactions to improve response accuracy over time.</p>
              </div>
            </div>
          </div>
        </section>
        <section
          className="py-2"
          style={{
            backgroundImage:
              'url("https://cdn.sanity.io/images/qdwjwavs/production/1b61aff240f3b4179f726a8793a18318ebcdee66-2880x1620.jpg?w=1600")',
          }}
        >
          <div className="container">
            <div className="row justify-content-end align-items-center">
              <div className="col-md-8 section-content">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 section-content">
                      <h2 className="text_48_how">Multichannel Interaction</h2>
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Seamless Integration:</strong> Operates across web, mobile apps, AI kiosks, and holo displays for a consistent user experience.</p>
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Multilingual Support:</strong> Supports multiple languages for global engagement and meaningful connections.</p>
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Privacy and Security:</strong> Ensures data privacy with robust encryption, secure transmission, and access controls.</p>
                    </div>
                  </div>
                </div>

                <div className="container">
                  <div className="row">
                    <h2 className="text_48_how">Interactive Therapy and Wellness Modules</h2>
                    <div className="col-md-12 section-content">
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Interactive Therapy Modules:</strong> Dynamic modules created by professionals to enhance mental and physical well-being.</p>
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Personalized Recommendations:</strong> Tailored strategies and resources based on user data and preferences.</p>
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>24/7 Availability:</strong> Access support anytime, with real-time assistance during emergencies.</p>
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Continuous Learning:</strong> Adapts and improves from user feedback for better service quality.</p>
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Risk Assessment and Interventions:</strong> Assesses risks for mental health issues and provides appropriate interventions.</p>
                      <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Empathy-Driven Support:</strong> AI-driven empathy offers personalized guidance for user progress.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="py-2"
          style={{
            backgroundImage:
              'url("https://cdn.sanity.io/images/qdwjwavs/production/1b61aff240f3b4179f726a8793a18318ebcdee66-2880x1620.jpg?w=1600")',
          }}
        >
          <div className="container">
            <h2 className="text_48_how">Unique Features of IMMSY</h2>
            <div className="row">
              <div className="col-md-12 section-content">
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Advanced NLP</strong></p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Emotion Recognition</strong></p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Tailored Recommendations</strong></p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Comprehensive Risk Assessment</strong></p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>24/7 Availability</strong></p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Adaptive Learning</strong></p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Top-Tier Privacy and Security Measures</strong></p>
              </div>
            </div>
          </div>

          <div className="container">
            <h2 className="text_48_how">Data Security and Legal Compliance</h2>
            <div className="row">
              <div className="col-md-12 section-content">
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Compliance with GDPR and HIPAA:</strong> Strictly follows data protection regulations, ensuring user data is securely stored.</p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Secure Storage of Sensitive Data:</strong> Stores emotional analysis, blood test results, and medical records securely.</p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Advanced Encryption Protocols:</strong> Uses robust security measures to protect data from unauthorized access.</p>
                <p className='text_18_how'><MdDataThresholding className="icon" /> <strong>Transparency and User Control:</strong> Provides users with complete control and transparency over their data.</p>
              </div>
            </div>
          </div>
        </section>

      </Layout>
    </>
  )
}

export default HowItWorks

